import { useEffect, useRef, useState } from "react";
import Image from "../images/Image";
import InputLabel from "../inputfields/InputLabel";
import SearchWithDropdown from "./SearchWithDropdown";
import DropDownModel from "./DropDownModel";
import ErrorMessage from "../ErrorMessages/ErrorMessage";
import DropdownFramer from "../framerMotion/DropdownFramer";
import InputShimmer from "../inputfields/InputShimmer";
import { inputFieldContent } from "../inputfields/InputFieldContent";
import useTranslation from "../CustomHooks/useTranslation";
import ToolTip from "../ToolTip/ToolTip";
import useApi from "../../services/useApi";


interface DropdownButtonProps {
  labelName: string;
  id: string;
  errorMessage?: string;
  required?: boolean;
  onChange?: (id: string, value: string) => void; // Accepts both id and value
  tabIndex: number;
  selectedValue?: Record<string, any>;
  handleSearchValue?: (value: string, id: string) => void;
  disabled?: boolean;
  noSearch?: boolean;
  className?: string;
  editLoading?: boolean;
  modalStyle?: string;
  customWidth?: boolean;
  loadMoreOptions?: (params: any) => void;
  testId?:string;
  setSearchedAccount?: (value: string) => void;
  dropdownTestId?:string;
  handelDynamicValue?: (value: Record<string, any>) => void;
  apiEndPoint?: string;
  dropdownTopClass?:string;
  toolTipClassName?: string;
  placeHolderValue?: string;
}

export default function 
DynamicDropdown({
  labelName,
  id,
  errorMessage,
  required,
  onChange,
  // handleSearchValue = () => null,
  apiEndPoint,
  selectedValue,
  disabled,
  noSearch = false,
  editLoading,
  className,
  modalStyle,
  testId,
  loadMoreOptions,
  setSearchedAccount,
  handelDynamicValue,
  dropdownTopClass,
  dropdownTestId,
  toolTipClassName,
  placeHolderValue
}: DropdownButtonProps) {
  const [isOpen, setIsOpen] = useState(false);
  const buttonRef = useRef<HTMLButtonElement>(null);
  const [buttonWidth,setButtonWidth] = useState(0)
  const { translate } = useTranslation(inputFieldContent);
  const { getAPI } = useApi();
  const [options, setOptions] = useState<string[]>([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const handleSearchValue = (value: string, id: string, page_number: number) => {
    setSearchedAccount?.(value);
    if(handelDynamicValue){
      setPageNumber(page_number)
      setTotalPages(1)
      getOptionList(value, page_number);
    }
    if (loadMoreOptions && value) {
      loadMoreOptions(value);
    }
  }
  const handleMoreData = (value: string) => {
    setPageNumber(pageNumber+1)
    getOptionList(value, pageNumber+1);
  }
  const handleSelect = (value: string, action: boolean, page_number: number) => {
    if (onChange) {
      onChange(id, value); // Pass both `id` and `value`
    }
    handleSearchValue(value, id, page_number);
    setIsOpen(action);
  };

  const handleSearch = (value: string, page_number: number) => {
    handleSearchValue(value, id, page_number);
  };
  const handleClose = (action: boolean) => {
    handleSearchValue("", id, 1);
    setIsOpen(action);
  };

  const getOptionList = async (search: string, page_number: number) => {
    if(page_number !== 1){
      if(page_number > totalPages) return;
    }
    try {
      const res = await getAPI(`${apiEndPoint}${page_number ? page_number : 1}${search.length !== 0 ? `&search=${encodeURIComponent(search.trim())}` : ""}`);
      setOptions(page_number === 1 ? res?.data?.data || [] : [...options, ...(res?.data?.data || [])]);
      setTotalPages(Math.ceil((res?.data?.total_count || 0) / 10))
    } catch (error) {
      console.error('Error fetching options:', error);
      setOptions([]);
      setTotalPages(1);
    }
  };
  useEffect(() => {
    getOptionList('', 1);
    setPageNumber(1)
    setTotalPages(1)
    if (buttonRef.current) {
      setButtonWidth(buttonRef.current.offsetWidth);
    }
  }, [isOpen]);
  
  return (
    <DropDownModel isOpen={isOpen} handleClose={handleClose} modalStyle={modalStyle}>
      <InputLabel labelName={labelName} id={id} required={required} />

      {editLoading ? <InputShimmer /> : <>
        <button
          ref={buttonRef}
          type="button"
          data-testid={testId || id}
          className={`${className} bg-white w-80 h-14 py-5 pr-[15px] disabled:bg-disable_fill disabled:border-disable_stroke pl-2.5 focus:pl-[9px] border rounded-lg text-subTitle outline-none focus:border-2 flex justify-between items-center ${errorMessage ? "border-negative" : "border-P_light_active"
            }`}
          disabled={disabled}
          onClick={() => handleClose(!isOpen)}
          // tabIndex={tabIndex}
        >
          <span
            className={`${(selectedValue && handelDynamicValue?.(selectedValue)) ? "text-primary_text" : "text-secondary_text"} group w-[95%] truncate flex flex-1 text-subTitle`}
          >
           <p className="truncate">{(selectedValue && handelDynamicValue?.(selectedValue)) || translate(`Select ${placeHolderValue ? placeHolderValue : labelName.toLowerCase()}`)}</p>
            {(selectedValue && handelDynamicValue?.(selectedValue)) && 
            <ToolTip ToolTipItem={handelDynamicValue?.(selectedValue) || ""} top={`left-0 ${toolTipClassName ? toolTipClassName : 'top-[1rem]'} `} />}

          </span>
          <DropdownFramer
            isDropdownVisible={isOpen}
          >
            <Image src={disabled ? "arrow_light" : "dropdown-down-arrow"} />
          </DropdownFramer>
        </button>
      </>}
      {isOpen && (
        <SearchWithDropdown
          options={options}
          handleSearchValue={handleSearch}
          id={id}
          onSelect={handleSelect}
          noSearch={noSearch}
          className={className}
          style={{ width: buttonWidth }}
          isInfiniteDropdown={true}
          fetchMoreData={handleMoreData}
          dropdownTestId={dropdownTestId}
          handelDynamicValue={handelDynamicValue}
          dynamicDropdown={true}
          dropdownTopClass={dropdownTopClass}
        />
      )}
      {errorMessage && <ErrorMessage errorMessage={errorMessage} testId={`error-${id}`}/>}
    </DropDownModel>
  );
}
